// @flow

import React from 'react';
import { Col, Panel, Grid } from 'react-bootstrap';
import CardDetailsForm from './form';
import './styles.css';

export default props => {
  const initialValues = {
    validMonths: 'January',
    validYears: 2017,
    country: 'GB'
  };
  return (
    <Grid>
      <Col>
        <Panel>
          <Panel.Heading>
            <h2 style={{ color: '#fa3737', margin: '10px 0' }}>Card Details</h2>
          </Panel.Heading>
          <Panel.Body>
           { localStorage.getItem("converted") === "true" && (<Col xs={12} md={6} className="text-center">
              <CardDetailsForm
                onSubmit={(r: any) => console.log(r)}
                info={props.info}
                lastBlurredField={props.lastBlurredField}
                validatePayment={props.validatePayment}
                lastBlurredState={props.lastBlurredState}
                basketId={props.basketId}
                initialValues={initialValues}
                makePayment={props.makePayment}
                totalToPay={props.basketData.totalToPay}
                payment={props.payment}
              />
            </Col>)}
          </Panel.Body>
        </Panel>
      </Col>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/CardDetails/index.js